import React from "react";
import { motion } from "framer-motion";

const EventCard = ({
  event,
  image,
  index = 0,
  className = "event-card border-0",
  showDescription = true, // Add this prop
}) => {
  return (
    <motion.div
      className={`card ${className}`}
      style={{ height: "330px", minWidth: "300px" }}
      key={`${event.title}-${index}`}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{
        duration: 0.6,
        delay: index * 0.1,
        ease: "easeOut",
      }}
    >
      <div className="card-body d-flex flex-column p-3">
        <div
          className="position-relative w-100 mb-3 overflow-hidden rounded-1"
          style={{
            height: "150px",
          }}
        >
          <img
            src={image}
            alt={event.title}
            className="w-100 h-100 object-fit-cover position-absolute "
            style={{
              top: 0,
              left: 0,
            }}
          />
        </div>

        <h5 className="fw-bold heading my-2" style={{ fontSize: "1.1rem" }}>
          {event.title}
        </h5>

        {/* Conditionally render the subtitle/description */}
        {showDescription && (
          <h6
            className="fw-semibold heading mb-2"
            style={{ fontSize: "0.95rem" }}
          >
            {event.subtitle}
          </h6>
        )}

        <p className="card-text mb-0 text-muted">{event.date}</p>
      </div>
    </motion.div>
  );
};

export default EventCard;
